import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tj-select',
  templateUrl: './tj-select.component.html',
  styleUrls: ['./tj-select.component.css']
})
export class TjSelectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  @Input() label: string;
  @Input() placeholder: string = "";
  @Input() disabled: boolean = false;
  @Input() opcoes: any[];


  selectedValue = null;
}
